export default __webpack_public_path__ + "static/media/WM0480.34I-43543_-26176_0.52ce8f2c.jpg";